import { createRouter, createWebHistory } from '@ionic/vue-router';
import Login from '../views/Login.vue';
import DosenMahasiswa from '../views/DosenMahasiswa.vue';
import DosenManajemen from '../views/DosenManajemen.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dosen',
    name: 'DosenDashboard',
    component: () => import('../views/DosenDashboard.vue')
  },
  {
    path: '/mahasiswa',
    name: 'MahasiswaDashboard',
    component: () => import('../views/MahasiswaDashboard.vue')
  },
  {
    path: '/laporan',
    name: 'LaporanPage',
    component: () => import('../views/Laporan.vue')
  },
  {
    path: '/profil',
    name: 'ProfilPage',
    component: () => import('../views/Profil.vue')
  },
  {
    path: '/dosen/kelas',
    name: 'DosenKelas',
    component: () => import('../views/DosenKelas.vue')
  },
  {
    path: '/dosen/qr/:id',
    name: 'DosenQRCode',
    component: () => import('../views/DosenQRCode.vue')
  },
  {
    path: '/dosen/mahasiswa',
    name: 'DosenMahasiswa',
    component: DosenMahasiswa
  },
  {
    path: '/dosen/manajemen',
    name: 'DosenManajemen',
    component: DosenManajemen
  },
  {
    path: '/dosen/laporan',
    name: 'DosenLaporan',
    component: () => import('../views/DosenLaporan.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
